<template>
  <h5>
    <slot />
  </h5>
</template>

<script>
export default {
  props: {},
};
</script>

<style scoped>
h5 {
  margin-top: 0;
  margin-bottom: 0;

  color: var(--gray-800);

  font-size: 20px;
  font-family: var(--font-family-sans);
  font-weight: 500;
  line-height: 30px;
  text-align: left !important; /* NOTE @chris Global leak. */
}
</style>
